import Icon from './eye-slash.svg?react'
import { createIcon } from './factory'

export const EyeSlash = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
